module.exports = __webpack_public_path__ + "static/media/bussen_vit.a1146ff9.svg";